<template>
  <div class="container" v-if="secret != null">
    <!-- Form -->
    <form ref="form" @submit.prevent="save">
      <fieldset class="detail-fieldset">
        <legend>{{ $t("patientForm.patientDetails") }}</legend>
        <div class="grid-box">
          <label for="firstname" class="label label-fn">
            {{ $t("patientForm.firstname") }}*
          </label>
          <b-form-input
            id="firstname"
            required
            v-model="firstnameValue"
            :placeholder="$t('patientForm.firstname')"
            class="input-fn"
            :state="statusForm.firstname"
            :disabled="wasPreSet.firstname"
          ></b-form-input>

          <label for="name" class="label label-ln">
            {{ $t("patientForm.lastname") }}*
          </label>
          <b-form-input
            id="name"
            required
            v-model="lastnameValue"
            :placeholder="$t('patientForm.lastname')"
            class="input-ln"
            :state="statusForm.lastname"
            :disabled="wasPreSet.lastname"
          ></b-form-input>

          <label for="birthname" class="label label-bn">
            {{ $t("patientForm.birthname") }}
          </label>
          <b-form-input
            id="birthname"
            v-model="birthnameValue"
            :placeholder="$t('patientForm.birthname')"
            class="input-bn"
            :disabled="wasPreSet.birthname"
          ></b-form-input>

          <label for="birthdate" class="label label-bd">
            {{ $t("patientForm.birthdate") }}*
          </label>
          <b-form-input
            id="birthdate"
            ref="birthdate"
            required
            v-model="birthdateValue"
            type="date"
            class="input-bd"
            :max="maxDate"
            :state="statusForm.birthdate"
            :disabled="wasPreSet.birthdate"
          ></b-form-input>

          <label for="gender" class="label label-g">
            {{ $t("patientForm.gender.gender") }}*
          </label>
          <b-form-select
            id="gender"
            required
            v-model="genderValue"
            class="input-g"
            :state="statusForm.gender"
            :disabled="wasPreSet.gender"
          >
            <b-form-select-option value="null" disabled>
              {{ $t("patientForm.placeholder.select") }}
            </b-form-select-option>
            <b-form-select-option
              v-for="option in optionsGender"
              :key="option.value"
              :value="option.value"
            >
              {{ $t("patientForm.gender." + option.text) }}
            </b-form-select-option>
          </b-form-select>

          <label for="organisation" class="label label-org">
            {{ $t("patientForm.organisation") }}*
          </label>
          <b-form-input
            id="organisation"
            disabled
            v-model="organisationValue"
            class="input-org"
            :state="statusForm.organisation"
          ></b-form-input>

          <label for="insuranceNumber" class="label label-insuranceNumber">
            {{ $t("patientForm.insuranceNumber") }}
          </label>
          <b-form-input
            id="insuranceNumber"
            v-model="insuranceNumberValue"
            :placeholder="$t('patientForm.insuranceNumber')"
            class="input-insuranceNumber"
            :disabled="wasPreSet.insuranceNumber"
          ></b-form-input>

          <label for="patientId" class="label label-pid">
            {{ $t("patientForm.patientId") }}
          </label>
          <b-form-input
            id="patientId"
            v-model="patientIdValue"
            :placeholder="$t('patientForm.patientId')"
            class="input-pid"
            :disabled="wasPreSet.patientId"
          ></b-form-input>

          <label for="caseId" class="label label-caseId">
            {{ $t("patientForm.caseId") }}
          </label>
          <b-form-input
            id="caseId"
            v-model="caseIdValue"
            :placeholder="$t('patientForm.caseId')"
            class="input-caseId"
            :disabled="wasPreSet.caseId"
          ></b-form-input>
        </div>
      </fieldset>
      
      <fieldset class="detail-fieldset">
        <legend>{{ $t("patientForm.patientAddress") }}</legend>
        <div class="grid-box-address">
          <label for="street" class="label label-str">
            {{ $t("patientForm.street") }}*
          </label>
          <b-form-input
            id="street"
            v-model="streetValue"
            required
            :placeholder="$t('patientForm.street')"
            class="input-str"
            :state="statusForm.street"
            :disabled="wasPreSet.street"
          ></b-form-input>

          <label for="housenr" class="label label-housenr">
            {{ $t("patientForm.houseNumber") }}*
          </label>
          <b-form-input
            id="housenr"
            required
            v-model="houseNumberValue"
            :placeholder="$t('patientForm.houseNumber')"
            class="input-housenr"
            :state="statusForm.houseNumber"
            :disabled="wasPreSet.houseNumber"
          ></b-form-input>

          <label for="plz" class="label label-plz">
            {{ $t("patientForm.postCode") }}*
          </label>
          <b-form-input
            id="plz"
            required
            v-model="postCodeValue"
            :placeholder="$t('patientForm.postCode')"
            class="input-plz"
            pattern="^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$"
            :state="statusForm.postCode"
            :disabled="wasPreSet.postCode"
          ></b-form-input>

          <label for="town" class="label label-t">
            {{ $t("patientForm.town") }}*
          </label>
          <b-form-input
            id="town"
            required
            v-model="townValue"
            :placeholder="$t('patientForm.town')"
            class="input-t"
            :state="statusForm.town"
            :disabled="wasPreSet.town"
          ></b-form-input>
        </div>
      </fieldset>
    </form>
    <form @submit.prevent="save">
      <fieldset style="margin-top: 1rem">
        <legend>{{ $t("consentQuestion.consentTitle") }}</legend>
        <div class="consent-form">
          <h6>
            {{ $t("consentQuestion.datenspende") }}
            <button
              type="button"
              class="btn btn-link my-btn-link"
              @click="showMore.datenspende = !showMore.datenspende"
            >
              <a v-if="!showMore.datenspende">{{
                $t("consentQuestion.showMore")
              }}</a>
              <a v-if="showMore.datenspende">{{
                $t("consentQuestion.showLess")
              }}</a>
            </button>
          </h6>
          <p
            v-html="$t('consentQuestion.datenspendeDetail')"
            v-if="showMore.datenspende"
          ></p>
          <b-form-group>
            <b-form-radio-group
              name="datenspende"
              required
              v-model="datenspende"
              stacked
              class="radio-btn"
            >
              <b-form-radio value="OPTIN" size="lg">
                {{ $t("consentQuestion.yes") }}
              </b-form-radio>
              <!-- <b-form-radio value="NOCONSENT" size="lg"> {{ $t('consentQuestion.no') }} </b-form-radio> -->
              <b-form-invalid-feedback :force-show="statusForm.datenspende">
                {{ $t("patientForm.required") }}
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
          <h6>
            {{ $t("consentQuestion.kontaktaufnahme_wissenschaftlich") }}
            <button
              type="button"
              class="btn btn-link my-btn-link"
              @click="
                showMore.kontaktaufnahme_wissenschaftlich = !showMore.kontaktaufnahme_wissenschaftlich
              "
            >
              <a v-if="!showMore.kontaktaufnahme_wissenschaftlich">{{
                $t("consentQuestion.showMore")
              }}</a>
              <a v-if="showMore.kontaktaufnahme_wissenschaftlich">{{
                $t("consentQuestion.showLess")
              }}</a>
            </button>
          </h6>
          <p
            v-html="
              $t('consentQuestion.kontaktaufnahme_wissenschaftlich_Detail')
            "
            v-if="showMore.kontaktaufnahme_wissenschaftlich"
          ></p>
          <b-form-group>
            <b-form-radio-group
              name="kontaktaufnahme_wissenschaftlich"
              required
              v-model="kontaktaufnahme_wissenschaftlich"
              stacked
              class="radio-btn"
            >
              <b-form-radio value="OPTIN" size="lg">
                {{ $t("consentQuestion.yes") }}
              </b-form-radio>
              <b-form-radio value="NOCONSENT" size="lg">
                {{ $t("consentQuestion.no") }}
              </b-form-radio>
              <b-form-invalid-feedback
                :force-show="statusForm.kontaktaufnahme_wissenschaftlich"
              >
                {{ $t("patientForm.required") }}
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
          <h6>
            {{ $t("consentQuestion.kontaktaufnahme_Zusatzbefunde") }}
            <button
              type="button"
              class="btn btn-link my-btn-link"
              @click="
                showMore.kontaktaufnahme_Zusatzbefunde = !showMore.kontaktaufnahme_Zusatzbefunde
              "
            >
              <a v-if="!showMore.kontaktaufnahme_Zusatzbefunde">{{
                $t("consentQuestion.showMore")
              }}</a>
              <a v-if="showMore.kontaktaufnahme_Zusatzbefunde">{{
                $t("consentQuestion.showLess")
              }}</a>
            </button>
          </h6>
          <p
            v-html="$t('consentQuestion.kontaktaufnahme_Zusatzbefunde_Detail')"
            v-if="showMore.kontaktaufnahme_Zusatzbefunde"
          ></p>
          <b-form-group>
            <b-form-radio-group
              name="kontaktaufnahme_Zusatzbefunde"
              required
              v-model="kontaktaufnahme_Zusatzbefunde"
              stacked
              class="radio-btn"
            >
              <b-form-radio value="OPTIN" size="lg">
                {{ $t("consentQuestion.yes") }}
              </b-form-radio>
              <b-form-radio value="NOCONSENT" size="lg">
                {{ $t("consentQuestion.no") }}
              </b-form-radio>
              <b-form-invalid-feedback
                :force-show="statusForm.kontaktaufnahme_Zusatzbefunde"
              >
                {{ $t("patientForm.required") }}
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </b-form-group>
        </div>
        <br />
        <b-form-checkbox
          v-model="confirm"
          name="confirm-data-donation"
          value="accepted"
          unchecked-value="not_accepted"
        >
          {{ $t("message.confirmImplicationSave") }}
        </b-form-checkbox>
        <b-form-invalid-feedback :force-show="statusForm.confirm">
          {{ $t("message.confirmImplicationSaveRequired") }}
        </b-form-invalid-feedback>
      </fieldset>
    </form>

    <!-- Button -->
    <b-button
      type="submit"
      variant="primary"
      @click="clickHandler()"
      class="save-btn"
    >
      {{ $t("save") }}
    </b-button>
    <!-- Modal -->
    <b-modal id="bv-modal-status" no-close-on-backdrop no-close-on-esc>
      <template #modal-header>
        <h5 id="bv-modal-status___BV_modal_title_" class="modal-title">{{ $t('status') }}</h5>
      </template>
      <spinner
        v-if="spinner.loading"
        :message="$t(spinner.message)"
        size="large"
        line-fg-color="#379880"
      />
      <div class="center" v-if="spinner.success === true">
        <div><check-icon class="icon-success" :size="64"></check-icon></div>
        <!-- <br/> -->
        <div>{{ $t(spinner.message) }}</div>
      </div>
      <div class="center" v-if="spinner.success === false">
        <div><error-icon class="icon-error" :size="64"></error-icon></div>
        <div>
          {{ $t(spinner.message) }}
          <br/>
          <a
            v-if="spinner.message === ('message.error.e400' || 'message.error.e5xx')"
            :href="reportError"
          > {{ $t("message.contactSupport") }} </a>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button id="bv-modal-status-ok" :disabled="disableOk" variant="primary" @click="ok">
          OK
        </b-button>
      </template>
    </b-modal>
  </div>
  <div class="container text-center mt-5" v-else>
    {{ $t("noSecret") }}
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import CheckIcon from "vue-material-design-icons/CheckCircleOutline";
import ErrorIcon from "vue-material-design-icons/CloseCircleOutline";

export default {
  name: "PatientDetailsForm",
  components: {
    Spinner,
    ErrorIcon,
    CheckIcon,
  },
  props: {
    secret: {
      type: String,
      default: null,
    },
    redirectUri: {
      type: String,
      default: null,
    },
    firstname: {
      type: String,
      default: null,
    },
    lastname: {
      type: String,
      default: null,
    },
    birthname: {
      type: String,
      default: null,
    },
    birthdate: {
      type: String,
      default: null,
    },
    gender: {
      type: String,
      default: null,
    },
    street: {
      type: String,
      default: null,
    },
    houseNumber: {
      type: String,
      default: null,
    },
    postCode: {
      type: String,
      default: null,
    },
    town: {
      type: String,
      default: null,
    },
    insuranceNumber: {
      type: String,
      default: null,
    },
    caseId: {
      type: String,
      default: null,
    },
    patientId: {
      type: String,
      default: null,
    },
    organisation: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showDetails: true,
      organizationSelector: {
        searchAttributes: [
          {
            name: "Name",
            value: "name:contains",
          },
        ],
        queryParams: {
          _sort: "name",
          active: true,
        },
      },
      optionsGender: [
        { value: "U", text: "unknown" },
        { value: "M", text: "male" },
        { value: "F", text: "female" },
        { value: "D", text: "divers" },
        { value: "O", text: "other" },
      ],
      maxDate: moment(new Date()).format("YYYY-MM-DD"),
      firstnameValue: this.firstname,
      lastnameValue: this.lastname,
      birthnameValue: this.birthname,
      birthdateValue: this.birthdate,
      genderValue: this.gender,
      streetValue: this.street,
      houseNumberValue: this.houseNumber,
      postCodeValue: this.postCode,
      townValue: this.town,
      insuranceNumberValue: this.insuranceNumber,
      caseIdValue: this.caseId,
      patientIdValue: this.patientId,
      organisationValue: this.organisation,
      datenspende: null,
      kontaktaufnahme_Zusatzbefunde: null,
      kontaktaufnahme_wissenschaftlich: null,
      disableOk: true,
      spinner: {
        // visible: false,
        success: null,
        message: "message.savingInProgress",
        loading: true,
      },
      statusForm: {
        firstname: null,
        lastname: null,
        birthdate: null,
        gender: null,
        street: null,
        houseNumber: null,
        postCode: null,
        town: null,
        datenspende: false,
        kontaktaufnahme_Zusatzbefunde: false,
        kontaktaufnahme_wissenschaftlich: false,
        confirm: false,
      },
      wasPreSet: {
        firstname: null,
        lastname: null,
        birthname: null,
        birthdate: null,
        gender: null,
        street: null,
        houseNumber: null,
        postCode: null,
        town: null,
        insuranceNumber: null,
        patientId: null,
        caseId: null,
        datenspende: false,
        kontaktaufnahme_Zusatzbefunde: false,
        kontaktaufnahme_wissenschaftlich: false,
        confirm: false,
      },
      confirm: "not_accepted",
      showMore: {
        datenspende: false,
        kontaktaufnahme_Zusatzbefunde: false,
        kontaktaufnahme_wissenschaftlich: false,
      },
      reportError: null
    };
  },
  watch: {
    birthdateValue: {
      immediate: true,
      handler() {
        if (this.birthdateValue != null) {
          if (this.birthdateValue.match("(\\d{2}).(\\d{2}).(\\d{4})")) {
            const pattern = /(\d{2}).(\d{2}).(\d{4})/;
            this.birthdateValue = moment(
              this.birthdateValue.replace(pattern, "$3-$2-$1")
            ).format("YYYY-MM-DD");
          } else {
            this.birthdateValue = moment(this.birthdateValue).format(
              "YYYY-MM-DD"
            );
          }
        }
      },
    },
  },
  methods: {
    onSelect(value) {
      this.organisationValue = value;
    },

    clickHandler() {
      // TODO
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        // return;
      }
      if (
        this.firstnameValue != null &&
        this.lastnameValue != null &&
        this.birthdateValue != null &&
        this.genderValue != null &&
        this.streetValue != null &&
        this.houseNumberValue != null &&
        this.postCodeValue != null &&
        this.townValue != null &&
        this.datenspende != null &&
        this.kontaktaufnahme_Zusatzbefunde != null &&
        this.kontaktaufnahme_wissenschaftlich != null &&
        this.confirm === "accepted"
      ) {
        this.$bvModal.show("bv-modal-status");
        this.onSubmit();
        this.statusForm = {
          firstname: null,
          lastname: null,
          birthdate: null,
          gender: null,
          street: null,
          houseNumber: null,
          postCode: null,
          town: null,
          datenspende: false,
          kontaktaufnahme_Zusatzbefunde: false,
          kontaktaufnahme_wissenschaftlich: false,
          confirm: false,
        };
        this.spinner.loading = true;
        this.spinner.success = null;
        this.disableOk = true;
      } else {
        if (!this.firstnameValue) {
          this.statusForm.firstname = false;
        } else {
          this.statusForm.firstname = null;
        }
        if (!this.lastnameValue) {
          this.statusForm.lastname = false;
        } else {
          this.statusForm.lastname = null;
        }
        if (this.birthdateValue.toString() === "Invalid date") {
          this.statusForm.birthdate = false;
        } else {
          this.statusForm.birthdate = null;
        }
        if (!this.genderValue) {
          this.statusForm.gender = false;
        } else {
          this.statusForm.gender = null;
        }
        if (!this.streetValue) {
          this.statusForm.street = false;
        } else {
          this.statusForm.street = null;
        }
        if (!this.houseNumberValue) {
          this.statusForm.houseNumber = false;
        } else {
          this.statusForm.houseNumber = null;
        }
        if (!this.postCodeValue) {
          this.statusForm.postCode = false;
        } else {
          this.statusForm.postCode = null;
        }
        if (!this.townValue) {
          this.statusForm.town = false;
        } else {
          this.statusForm.town = null;
        }
        if (!this.datenspende) {
          this.statusForm.datenspende = true;
        } else {
          this.statusForm.datenspende = false;
        }
        if (!this.kontaktaufnahme_Zusatzbefunde) {
          this.statusForm.kontaktaufnahme_Zusatzbefunde = true;
        } else {
          this.statusForm.kontaktaufnahme_Zusatzbefunde = false;
        }
        if (!this.kontaktaufnahme_wissenschaftlich) {
          this.statusForm.kontaktaufnahme_wissenschaftlich = true;
        } else {
          this.statusForm.kontaktaufnahme_wissenschaftlich = false;
        }
        if (this.confirm === "not_accepted") {
          this.statusForm.confirm = true;
        } else {
          this.statusForm.confirm = false;
        }
      }
    },

    onSubmit() {
      let form = {
        firstName: this.firstnameValue,
        lastName: this.lastnameValue,
        birthName: this.birthnameValue,
        birthDate: this.birthdateValue,
        gender: this.genderValue,
        pid: this.patientIdValue,
        cid: this.caseIdValue,
        managingOrganization: this.organisationValue,
        insuranceNumber: this.insuranceNumberValue,
        contacts: [
          {
            streetAndNumber: this.streetValue + " " + this.houseNumberValue,
            zip: this.postCodeValue,
            city: this.townValue,
          },
        ],
        consent: {
          datenspende: this.datenspende,
          kontaktaufnahmeZusatzbefunde: this.kontaktaufnahme_Zusatzbefunde,
          kontaktaufnahmeWissenschaftlich: this
            .kontaktaufnahme_wissenschaftlich,
        },
      };
      // console.log(form);
      // console.log(JSON.stringify(form));
      // console.log(this.secret);

      this.spinner.message = "";

      const urlApi = process.env.VUE_APP_API_URL + "consent";
      this.post(urlApi, form, this.secret, {}).then(
        () => {
          setTimeout(() => {
            this.spinner.loading = false;
            this.spinner.success = true;
            this.disableOk = false;
            this.spinner.message = "message.success";
          }, 250);
        },
        (error) => {
          setTimeout(() => {
            this.spinner.loading = false;
            this.spinner.success = false;

            // console.log(error.response);

            if (error.response.status === 400 && error.response.data.startsWith("Organisation nicht valide")) {
              this.spinner.message = "message.error.e400";
              this.reportError = "mailto:support@molit.eu?subject=[Datenspende]%20Fehlende%20Organisation&body=Die%20Organisation%20"+ this.organisationValue +"%20konnte%20vom%20Server%20nicht%20verifiziert%20werden.";
            } else if (error.response.status === 401) {
              this.spinner.message = "message.error.e401";
            } else if (error.response.status === 403) {
              this.spinner.message = "message.error.e403";
            } else if (error.response.status === 404) {
              this.spinner.message = "message.error.e404";
            } else if (error.response.status === 409) {
              this.spinner.message = "message.error.e409";
            } else if (
              error.response.status >= 400 &&
              error.response.status < 500
            ) {
              this.spinner.message = "message.error.e4xx";
            } else if (error.response.status === 502) {
              this.spinner.message = "message.error.e404";
            } else {
              this.spinner.message = "message.error.e5xx";
              this.reportError = "mailto:support@molit.eu?subject=[Datenspende]%20Interner%20Serverfehler&body=Es%20ist%20ein%20interner%20Serverfehler%20aufgetreten.";
            }

            this.disableOk = false;
            console.error(error);
          }, 250);
        }
      );
    },
    ok() {
      this.$bvModal.hide('bv-modal-status')
      if(this.redirectUri != null && !this.spinner.message.startsWith("message.error")) {
        this.redirect();
      }
    },
    redirect() {      
        let data = {};
        if (this.datenspende != null) {
          data = { ...data, consentGeneral: this.datenspende };
        }
        if (this.kontaktaufnahme_Zusatzbefunde != null) {
          data = { ...data, consentContactFindings: this.kontaktaufnahme_Zusatzbefunde };
        }
        if (this.kontaktaufnahme_wissenschaftlich != null) {
          data = { ...data, consentContactScientific: this.kontaktaufnahme_wissenschaftlich };
        }        
        const searchParams = new URLSearchParams(data);
      window.location.href = this.redirectUri + "?" + searchParams.toString();
    },

    /**
     * Performs an ajax post request using axios
     *
     * @param {string} url - request url
     * @param {Object} [content={}] - request body data in json format
     * @param {string} [token] - the token
     * @param {Object} [params={}] - the query parameters for the get request as object (e.g. { zoneId: "Europe/Berlin" } )
     * @returns {Promise} - the Promise containing the result of the HTTP request
     */
    post(url, content = {}, token, params = {}) {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (token) {
        headers.Authorization = "Bearer " + token;
      }

      const config = {
        headers,
        params,
      };

      return axios.post(url, content, config);
    },

    checkProps() {
      if (this.firstname != null) {
        this.wasPreSet.firstname = true;
      }
      if (this.lastname != null) {
        this.wasPreSet.lastname = true;
      }
      if (this.birthname != null) {
        this.wasPreSet.birthname = true;
      }
      if (this.birthdate != null) {
        this.wasPreSet.birthdate = true;
      }
      if (this.gender != null) {
        this.wasPreSet.gender = true;
      }
      if (this.street != null) {
        this.wasPreSet.street = true;
      }
      if (this.houseNumber != null) {
        this.wasPreSet.houseNumber = true;
      }
      if (this.postCode != null) {
        this.wasPreSet.postCode = true;
      }
      if (this.town != null) {
        this.wasPreSet.town = true;
      }
      if (this.insuranceNumber != null) {
        this.wasPreSet.insuranceNumber = true;
      }
      if (this.patientId != null) {
        this.wasPreSet.patientId = true;
      }
      if (this.caseId != null) {
        this.wasPreSet.caseId = true;
      }
    },
  },
  mounted() {
    this.checkProps();
  },
};
</script>
<style lang="scss" scoped>
.my-btn-link {
  vertical-align: inherit !important;
  padding: 0;
}

.detail-fieldset {
  margin-top: 1rem;
}

.consent-form {
  margin: 0.3rem 1em 1em 2rem;
}

.radio-btn {
  margin-left: 1rem;
}

.label {
  text-align: right;
  margin-top: 0.5rem;
  white-space: nowrap;
}
.grid-box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1max-content 1max-content 1max-content 1max-content 1max-content 1max-content;
  gap: 8px 10px;
  grid-template-areas:
    "label-fn     input-fn      input-fn      label-ln      input-ln      input-ln      label-bn      input-bn      input-bn      "
    "label-bd     input-bd      input-bd      label-g       input-g       input-g       .             .             .             "
    "label-org    input-org     input-org     input-org     input-org     input-org     input-org     input-org     input-org     "
    "label-insuranceNumber   input-insuranceNumber    input-insuranceNumber    label-pid     input-pid     input-pid     label-caseId  input-caseId  input-caseId  ";
  margin: 0.3rem 1em 1em 2rem;
}
.grid-box-address {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1max-content 1max-content 1max-content 1max-content 1max-content 1max-content;
  gap: 8px 10px;
  grid-template-areas:
    "label-str    input-str     input-str     input-str     input-str     input-str     label-housenr input-housenr input-housenr "
    "label-plz    input-plz     input-plz     label-t       input-t       input-t       input-t       input-t       input-t       ";
  margin: 0.3rem 1em 1em 2rem;
}
@media only screen and (max-width: 990px) {
  .grid-box {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1max-content 1max-content 1max-content;
    gap: 8px 10px;
    grid-template-areas:
      "label-fn       input-fn      input-fn"
      "label-ln       input-ln      input-ln"
      "label-bn       input-bn      input-bn"
      "label-bd       input-bd      input-bd"
      "label-g        input-g       input-g"
      "label-org      input-org     input-org"
      "label-insuranceNumber     input-insuranceNumber    input-insuranceNumber"
      "label-pid      input-pid     input-pid"
      "label-caseId   input-caseId  input-caseId";
    margin: 0.3rem 1em 1em 2rem;
  }
  .grid-box-address {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1max-content 1max-content 1max-content;
    gap: 8px 10px;
    grid-template-areas:
      "label-str      input-str     input-str"
      "label-housenr  input-housenr input-housenr"
      "label-plz      input-plz     input-plz"
      "label-t        input-t       input-t";
    margin: 0.3rem 1em 1em 2rem;
  }
}
@media only screen and (max-width: 500px) {
  .grid-box {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1max-content;
    gap: 0px 0px;
    grid-template-areas:
      "label-fn"
      "input-fn"
      "label-ln"
      "input-ln"
      "label-bn"
      "input-bn"
      "label-bd"
      "input-bd"
      "label-g"
      "input-g"
      "label-org"
      "input-org"
      "label-str"
      "input-str"
      "label-housenr"
      "input-housenr"
      "label-plz"
      "input-plz"
      "label-t"
      "input-t"
      "label-insuranceNumber"
      "input-insuranceNumber"
      "label-pid"
      "input-pid"
      "label-caseId"
      "input-caseId";
    margin: 0.3rem 1em 1em 2rem;
  }
  .grid-box-address{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1max-content;
    gap: 0px 0px;
    grid-template-areas:
      "label-str"
      "input-str"
      "label-housenr"
      "input-housenr"
      "label-plz"
      "input-plz"
      "label-t"
      "input-t";
    margin: 0.3rem 1em 1em 2rem;
  }
  .label {
    text-align: left;
    white-space: nowrap;
  }
}
.label-fn {
  grid-area: label-fn;
}
.input-fn {
  grid-area: input-fn;
}
.label-bd {
  grid-area: label-bd;
}
.input-bd {
  grid-area: input-bd;
}
.label-str {
  grid-area: label-str;
}
.input-str {
  grid-area: input-str;
}
.label-plz {
  grid-area: label-plz;
}
.input-plz {
  grid-area: input-plz;
}
.label-insuranceNumber {
  grid-area: label-insuranceNumber;
}
.input-insuranceNumber {
  grid-area: input-insuranceNumber;
}
.label-caseId {
  grid-area: label-caseId;
}
.input-caseId {
  grid-area: input-caseId;
}
.label-pid {
  grid-area: label-pid;
}
.input-pid {
  grid-area: input-pid;
}
.label-org {
  grid-area: label-org;
}
.input-org {
  grid-area: input-org;
}
.label-bn {
  grid-area: label-bn;
}
.input-bn {
  grid-area: input-bn;
}
.label-ln {
  grid-area: label-ln;
}
.input-ln {
  grid-area: input-ln;
}
.label-g {
  grid-area: label-g;
}
.input-g {
  grid-area: input-g;
}
.label-housenr {
  grid-area: label-housenr;
}
.input-housenr {
  grid-area: input-housenr;
}
.label-t {
  grid-area: label-t;
}
.input-t {
  grid-area: input-t;
}
.save-btn {
  float: right;
  margin-right: 15px;
  margin-bottom: 3rem;
  min-width: 140px;
}
@mixin icon-basic {
  margin-bottom: 30px;
}
.icon-success {
  @include icon-basic;
  color: #379880;
}
.icon-error {
  @include icon-basic;
  color: #bf0023;
}
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
